import { parseFeatureFlag } from '@/utils/featureFlags'

/**
 * Build-time safety gate for the instance Subscription rollout.
 * Keep disabled unless the target environment has the matching backend capability and catalog.
 */
export const INSTANCE_SUBSCRIPTION_ENABLED = parseFeatureFlag(
  import.meta.env.VITE_ENABLE_INSTANCE_SUBSCRIPTION,
)

/**
 * Build-time switch for the Extra Specification CPU:RAM ratio rule on the Create Instance page.
 * Disabled by default: extra vCPU and RAM are then independent, step by 1, and are only capped by
 * what the machine actually provides; extra disk steps by 50 GB. Enable to restore the
 * power-of-two CPU options, the RAM = CPU x {1,2,4,8,16} ratio and the 100 GB disk step.
 */
export const EXTRA_SPEC_RATIO_ENABLED = parseFeatureFlag(
  import.meta.env.VITE_ENABLE_EXTRA_SPEC_RATIO,
)

/**
 * Build-time switch for the team-login "must reset password" check
 * (`suggestion.needUpdatePassword` from user info). The reset-password backend is
 * currently offline, so leave this disabled to skip the forced password change
 * on first team login. Enable once the backend is back.
 */
export const TEAM_PASSWORD_RESET_CHECK_ENABLED = parseFeatureFlag(
  import.meta.env.VITE_ENABLE_TEAM_PASSWORD_RESET_CHECK,
)
